import moment from 'moment';

// Router
export const adminRoot = '';
export const searchPath = `${adminRoot}/#`;

// Language
export const defaultLocale = 'en-AU';
export const defaultDirection = 'ltr';
export const localeOptions = [
	{ id: 'en-AU', name: 'English', direction: 'ltr' },
	{ id: 'zh-CN', name: '简体中文', direction: 'ltr' },
	{ id: 'zh-HK', name: '繁体中文', direction: 'ltr' },
	{ id: 'vi-VN', name: 'Tiếng Việt', direction: 'ltr' },
	{ id: 'ja-JP', name: '日本語', direction: 'ltr' },
];

export const configHelperAccess = {
	merchantId: '',
	branchId: '*',
	roles: ['Config Helper'],
	permissions: [
		{ application: 'eagle-mgt', permissions: ['*'] },
		{ application: 'kiwi-mgt', permissions: ['*'] },
		{ application: 'wombat-mgt', permissions: ['*'] },
		{ application: 'eagle-admin', permissions: ['*'] },
		{ application: 'echidna-api', permissions: ['*'] },
		{ application: 'numbat-api', permissions: ['*'] },
	],
};

export const configHelperAccessSuper = {
	merchantId: '',
	branchId: '*',
	roles: ['Config Helper', 'Super'],
	permissions: [
		{ application: 'eagle-mgt', permissions: ['*'] },
		{ application: 'kiwi-mgt', permissions: ['*'] },
		{ application: 'wombat-mgt', permissions: ['*'] },
		{ application: 'eagle-admin', permissions: ['*'] },
		{ application: 'echidna-api', permissions: ['*'] },
		{ application: 'numbat-api', permissions: ['*'] },
	],
};

// Auth
export const isAuthGuardActive = true;
export const defaultUser = {
	id: null,
	username: 'System',
	token: '',
	gatewayToken: '',
	avatar: '',
	email: '',
	isTempPass: false,
	nickName: '',
	phone: '',
	phoneRegion: 1,
	status: 1,
	type: null,
};
export const defaultAssignments = {
	list: [],
	id: null,
};
export const defaultRolesAndPermissions = {
	list: [
		{
			roles: [],
			permissions: [],
			branchId: '*',
		},
	],
	id: null,
	mid: null,
	expiry: null,
};
export const defaultSystemName = 'merchant-portal';

export const defaultBranch = {
	branchId: '*',
	branchName: 'All',
};

// UI
/* Menu Types: "menu-default", "menu-sub-hidden", "menu-hidden */
export const defaultMenuType = 'menu-default';
export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const isMultiColorActive = false;
export const defaultColor = 'light.default';
export const getDefaultColor = (flavor) => {
	if (flavor !== 'Zii') {
		return defaultColor.replace('default', flavor.toLowerCase());
	}
	return defaultColor;
};
export const isDarkSwitchActive = true;
export const colors = [
	'default',
	'bluenavy',
	'blueyale',
	'blueolympic',
	'greenmoss',
	'greenlime',
	'purplemonster',
	'redruby',
	'yellowgranola',
	'greysteel',
];

export const defaultReportFilter = {
	range: 0,
	start: moment().startOf('day'),
	end: moment().endOf('day'),
	allDay: true,
	vsRange: 1,
	vsStart: moment().subtract(1, 'days').startOf('day'),
	vsEnd: moment().subtract(1, 'days').endOf('day'),
	groupBy: 1,
	step: 5,
	location: { label: 'All locations', value: '*' },
	locationIds: '',
};
export const disclaimer =
	"ZiiTech operates in a fully PCI DSS compliant environment, all payment details captured are securely transmitted and processed by ZiiTech's payment gateway powered by Stripe Payments Australia Pty. Ltd.. Ziitech do not retain any customer card data, all recurring payments are processed via Stripe Saving Card API (Tokenisation technology) to ensure customer card data is always stored and processed securely on the payment gateway.";

// Storage keys
export const themeColorStorageKey = '__theme_selected_color';
export const themeRadiusStorageKey = '__theme_radius';
export const localeStorageKey = '__locale';
export const localeDirectionStorageKey = '__locale_direction';
export const authUserStorageKey = '__auth_user';
export const authAssignmentsStorageKey = '__auth_assignments';
export const authRoleAndPermissionsStorageKey = '__auth_roles_permissions';
export const authLocalPermissionsStorageKey = '__auth_local_permissions';
export const oauthUserStorageKey = '__oauth_user';
export const workspaceMerchantStorageKey = '__workspace_merchant';
export const workspaceBranchStorageKey = '__workspace_branch';
export const workspaceBranchIdsStorageKey = '__workspace_branch_ids';
export const workspaceSubscriptionsStorageKey = '__workspace_subscriptions';
export const workspaceAssignedLicenseStorageKey =
	'__workspace_assigned_licenses_subscriptions';
export const workspaceReportFilterStorageKey = '__workspace_report_filter';
export const authSubscription = '__auth_subscription';

export * from './defaultValues';

// Table default pageNum pageSize
export const defaultPageValueForReport = {
	pageNum: 1,
	pageSize: 15,
	pageSizeOptions: [10, 20, 30, 50, 100, 200],
};

// Menu
export const ocEnableMerchantIds = [
	'ziigray-pty-ltd',
	'okami',
	'TS0000001',
	'demo-franchise',
	'ziitech-demo-2',
];
